import { render, staticRenderFns } from "./SingleActivity.vue?vue&type=template&id=3b1196d6&scoped=true"
import script from "./SingleActivity.vue?vue&type=script&lang=js"
export * from "./SingleActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1196d6",
  null
  
)

export default component.exports